import { render, staticRenderFns } from "./Firma.vue?vue&type=template&id=02c33434&scoped=true"
import script from "./Firma.vue?vue&type=script&lang=js"
export * from "./Firma.vue?vue&type=script&lang=js"
import style0 from "./Firma.vue?vue&type=style&index=0&id=02c33434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c33434",
  null
  
)

export default component.exports